/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.multicastGroup', [])
    .factory('multicastGroupService', MulticastGroupService)
    .name;

/*@ngInject*/
function MulticastGroupService($http, $q) {

    var service = {
        deleteMulticastGroup: deleteMulticastGroup,
        getMulticastGroup: getMulticastGroup,
        saveMulticastGroup: saveMulticastGroup,
        getApplicationMulticastGroups: getApplicationMulticastGroups,
        getCustomerMulticastGroups: getCustomerMulticastGroups,
        getSubCustomerMulticastGroups: getSubCustomerMulticastGroups,
        addDevicesToMulticastGroup: addDevicesToMulticastGroup,
        deleteDeviceFromMulticastGroup: deleteDeviceFromMulticastGroup,
    };

    return service;

    function getApplicationMulticastGroups(applicationId) {
        var deferred = $q.defer();
        $http.get(`/api/application/${applicationId}/multicastGroups`, null).then(function success(response) {
                deferred.resolve(response.data);
            }, function fail() {
                deferred.reject();
            });
        return deferred.promise;
    }

    function getCustomerMulticastGroups (customerId) {
        var deferred = $q.defer();
        $http.get(`/api/customer/${customerId}/multicastGroups`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSubCustomerMulticastGroups(subCustomerId) {
        var deferred = $q.defer();
        $http.get(`/api/subCustomer/${subCustomerId}/multicastGroups`, null).then(function success(response) {
            deferred.resolve(response.data, response.totalElements);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getMulticastGroup (multicastGroupId) {
        var deferred = $q.defer();
        var url = '/api/multicastGroup/' + multicastGroupId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveMulticastGroup (multicastGroup) {
        var deferred = $q.defer();
        var url = '/api/multicastGroup';
        $http.post(url, multicastGroup).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteMulticastGroup (multicastGroupId) {
        var deferred = $q.defer();
        var url = '/api/multicastGroup/' + multicastGroupId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function addDevicesToMulticastGroup (multicastGroupId, devicesObj) {
        var deferred = $q.defer();
        $http.post(`/api/multicastGroup/${multicastGroupId}/devices`, devicesObj).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteDeviceFromMulticastGroup (multicastGroupId, deviceId) {
        var deferred = $q.defer();
        $http.delete(`/api/multicastGroup/${multicastGroupId}/device/${deviceId}`).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/api/multicast-group.service.js